// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Asegúrate de que el menú desplegable se superponga en todas las pantallas */
.navbar-app {
  background-color: #e7e7e7;
  border-bottom: 1px solid #c9d2da;
  padding: 0;
  position: relative;
}

.nav-link-custom {
  text-decoration: none;
  color: #515356;
  display: flex;
  align-items: center;
}

.nav-link-custom:hover {
  background: #cad4e0;
  color: #515356;
}

.image-logo {
  margin-left: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.image-logo-small {
  margin-left: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.image-logo-small p {
  color: #515356;
  font-size: 10px;
  margin: 0;
}

.image-logo p {
  color: #515356;
  font-size: 10px;
  margin: 0;
}

/* Estilo para el ícono de FaBars dentro del dropdown */
.navbar-nav a.dropdown-toggle{
margin-right: 10px;
}

.navbar-nav i{
  font-size: 20px;
}

.navbar-nav a.dropdown-toggle::after {
  display: none !important;
}

.topbar-dropdown .fa {
  display: inline-block;
  font-size: 1.5rem;
  color: #515356;
  text-rendering: auto;
  -webkit-font-smoothing: antialiased;
}

.img-profile {
  border-radius: 50%;
  margin-right: 10px;
}

/* Ajuste del menú desplegable para que se superponga sin empujar el contenido */
.dropdown-menu {
  position: absolute;
  top: 100%; /* Posición debajo del botón de dropdown */
  right: 0;
  left: auto;
  z-index: 1050;
  display: none;
}

/* Mostrar el menú cuando esté activo */
.show > .dropdown-menu {
  display: block;
}

.dropdown label{
  cursor: pointer;
}

.dropdown-item-icon{
  display: flex;
  width: 65%;
  padding-left: 16px;
  justify-content: space-between;
  align-items: center;
}

.dropdown-item-span {
  display: inline-flex;
  color: #46127bc5;
  align-items: center;
  padding-left: 16px;
}


/* Ajustes específicos para pantallas pequeñas */
@media (max-width: 992px) {
  .navbar-collapse {
    display: contents;
    /* justify-content: flex-end; */
  }
  
  .navbar-nav {
    flex-direction: row;
    align-items: center;
  }
  
  /* Ajuste adicional para el tamaño del ícono */
  .topbar-dropdown .fa {
    font-size: 1.8rem;
  }
}


`, "",{"version":3,"sources":["webpack://./src/components/Topbar/Topbar.css"],"names":[],"mappings":"AAAA,8EAA8E;AAC9E;EACE,yBAAyB;EACzB,gCAAgC;EAChC,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,SAAS;AACX;;AAEA;EACE,cAAc;EACd,eAAe;EACf,SAAS;AACX;;AAEA,uDAAuD;AACvD;AACA,kBAAkB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,cAAc;EACd,oBAAoB;EACpB,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,gFAAgF;AAChF;EACE,kBAAkB;EAClB,SAAS,EAAE,0CAA0C;EACrD,QAAQ;EACR,UAAU;EACV,aAAa;EACb,aAAa;AACf;;AAEA,uCAAuC;AACvC;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,UAAU;EACV,kBAAkB;EAClB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;;AAGA,gDAAgD;AAChD;EACE;IACE,iBAAiB;IACjB,+BAA+B;EACjC;;EAEA;IACE,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA,8CAA8C;EAC9C;IACE,iBAAiB;EACnB;AACF","sourcesContent":["/* Asegúrate de que el menú desplegable se superponga en todas las pantallas */\n.navbar-app {\n  background-color: #e7e7e7;\n  border-bottom: 1px solid #c9d2da;\n  padding: 0;\n  position: relative;\n}\n\n.nav-link-custom {\n  text-decoration: none;\n  color: #515356;\n  display: flex;\n  align-items: center;\n}\n\n.nav-link-custom:hover {\n  background: #cad4e0;\n  color: #515356;\n}\n\n.image-logo {\n  margin-left: 10px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.image-logo-small {\n  margin-left: 10px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.image-logo-small p {\n  color: #515356;\n  font-size: 10px;\n  margin: 0;\n}\n\n.image-logo p {\n  color: #515356;\n  font-size: 10px;\n  margin: 0;\n}\n\n/* Estilo para el ícono de FaBars dentro del dropdown */\n.navbar-nav a.dropdown-toggle{\nmargin-right: 10px;\n}\n\n.navbar-nav i{\n  font-size: 20px;\n}\n\n.navbar-nav a.dropdown-toggle::after {\n  display: none !important;\n}\n\n.topbar-dropdown .fa {\n  display: inline-block;\n  font-size: 1.5rem;\n  color: #515356;\n  text-rendering: auto;\n  -webkit-font-smoothing: antialiased;\n}\n\n.img-profile {\n  border-radius: 50%;\n  margin-right: 10px;\n}\n\n/* Ajuste del menú desplegable para que se superponga sin empujar el contenido */\n.dropdown-menu {\n  position: absolute;\n  top: 100%; /* Posición debajo del botón de dropdown */\n  right: 0;\n  left: auto;\n  z-index: 1050;\n  display: none;\n}\n\n/* Mostrar el menú cuando esté activo */\n.show > .dropdown-menu {\n  display: block;\n}\n\n.dropdown label{\n  cursor: pointer;\n}\n\n.dropdown-item-icon{\n  display: flex;\n  width: 65%;\n  padding-left: 16px;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.dropdown-item-span {\n  display: inline-flex;\n  color: #46127bc5;\n  align-items: center;\n  padding-left: 16px;\n}\n\n\n/* Ajustes específicos para pantallas pequeñas */\n@media (max-width: 992px) {\n  .navbar-collapse {\n    display: contents;\n    /* justify-content: flex-end; */\n  }\n  \n  .navbar-nav {\n    flex-direction: row;\n    align-items: center;\n  }\n  \n  /* Ajuste adicional para el tamaño del ícono */\n  .topbar-dropdown .fa {\n    font-size: 1.8rem;\n  }\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
